<template>
    <v-menu v-if="mode === 'select'">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on"  text>
            <v-img v-if="$t('id') === 'es'" max-width="2rem" src="@/assets/es/flag.png" />
            <v-img v-if="$t('id') === 'pt'" max-width="2rem" src="@/assets/pt/flag.png" />
            <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="changeLocale(lang)" v-for="lang in languages" :key="lang.id" link>{{lang.title}}</v-list-item>
      </v-list>
    </v-menu>
    <div v-else>
        <v-btn-toggle>
            <v-btn :class="{'purple white--text': getCurrentLocale() === lang.value}" x-small v-for="lang in languages" @click="changeLocale(lang)">{{ lang.value }}</v-btn>
        </v-btn-toggle>
    </div>
</template>
<script>

export default {
    props: ['mode'],
    data: () => ({
        languages: [
            {id: 1, value: 'es', title: 'Español'},
            {id: 2, value: 'pt', title: 'Português'},
        ],
        selected: {id: 1, value: 'es', title: 'Español'}
    }),
    mounted(){
        // Sincroniza o botão selecionado com o idioma do sistema
        let quest = localStorage.getItem('locale') || (this.$i18n && this.$i18n.locale) || 'pt';
        const currentLanguage = this.languages.find(v => v.value === quest);
        if (currentLanguage) {
            this.selected = currentLanguage;
            // Força aplicar o idioma no sistema
            document.documentElement.setAttribute('lang', currentLanguage.value);
            this.$i18n.locale = currentLanguage.value;
            this.$vuetify.lang.current = currentLanguage.value;
            
            // Salva no localStorage caso não exista
            if(!localStorage.getItem('locale')) {
                localStorage.setItem('locale', currentLanguage.value);
            }
        }
    },
    methods: {
        getCurrentLocale() {
            return this.selected.value;
        },
        changeLocale(language){
            document.documentElement.setAttribute('lang', language.value);
            localStorage.setItem('locale', language.value);
            this.selected = language;
            this.$vuetify.lang.current = language.value;
            location.reload();
        }
    }
}
</script>